import { render, staticRenderFns } from "./SeminarPanel.vue?vue&type=template&id=3108f986&scoped=true&"
import script from "./SeminarPanel.vue?vue&type=script&lang=js&"
export * from "./SeminarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SeminarPanel.vue?vue&type=style&index=0&id=3108f986&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108f986",
  null
  
)

export default component.exports